<template>
  <div class="about" >
    <div class="d-flex flex-column min-vh-100">
    <a-spin tip="資料載入中..." :spinning="spinning">
    <Menubar msg="test" @query="query" @getwinsize="getwinsize" v-if="type=='N'" ref="MyBar" />  
      <div class="lineHeader" v-if="type=='Y'">
        <a-button type="link" @click="toNext()"  class="fontstyle-large">
          <b-icon  style="margin-right: 0.5rem;" scale="1.3" icon="chevron-left" variant="dark" />
          回上一頁
        </a-button>      
      </div>
      <div style="padding:2.4rem 0 0 0;" v-if="type=='Y'" />        
      <ul>
        <li>
          <div class="mt-3" >
            <div v-if="type=='N'" style="padding:0.8rem;background: linear-gradient(135deg, #f8fafc, #e2e8f0);border-top-left-radius: 15px;border-top-right-radius: 15px;box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);">
            <a-button type="link" @click="toNext()" class="fontstyle2-large" >
              <b-icon  style="margin-right: 0.6rem;" scale="1.3" icon="chevron-left" variant="primary" />
               回上一頁 
            </a-button>
            </div>              
            <Regapply v-if="JSON.stringify(this.objs)!=='{}'" :kinds="type" :obj="objs" @reload="reload()" />
          </div>
        </li>
      </ul>          
    </a-spin>  
    <div class="wrapper flex-grow-1"></div>      
    <Footbar msg="test" v-if="type=='N'" />
    <div class="applyfooter" v-if="windowsize.width<=991">
    </div>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex';
import { macService } from '../_services'
import { checktokens } from "../api/utils";
import * as moment from "moment/moment";
import Regapply from './panel/Regapply.vue'
import Menubar from '@/components/Menubar.vue'
import Footbar from '@/components/Footbar.vue'
import router from '../router'

const queryData = params => {
  return macService.macfind(params.id) 
};

const queryData3 = params => {
  return macService.macfindall(params.id,params.uid) 
};

export default {
  name: 'Regjoin',
  components: {
    Menubar,
    Footbar,
    Regapply,
  }, 
  props: {
    msg: String
  }, 
  data() {
    return {
      windowsize: {
            width: 0,
            height: 0
        },  
      spinning: true,      
      classtheme:null,
      objs: {}, 
      type:'N',     
      uId:'',
    };
  },  
  mounted(){
        //console.log(this.$route.query.userId);
        this.reload()
        this.$refs["MyBar"].closebar(false);
  },
  computed: {
    ...mapState("account", ["status", "user"]),
  },  
  methods: {  
    query(rs){
      this.classtheme = rs
    },
    getwinsize(val){
      this.windowsize.width = val.width
      this.windowsize.height = val.height
    },         
    fetch(params = {}) {
      queryData({
        ...params,
      }).then(({ data }) => {
          this.objs = data;
      });
    },
    fetch3(params = {}) {
      queryData3({
        ...params,
      }).then(({ data }) => {
          this.objs = data;
          this.spinning = false;
      });
    },    
    fdateformat(val){
        return moment(val).format("YYYY-MM-DD HH:mm"); 
    },
    check(){
        if(this.user!==null){
            let verify= checktokens(String(this.status.token))                  
            if(verify===null){ 
               router.push({ name: 'Actinfo', params: { id: this.uId }})           
            }
        }else{
            router.push({ name: 'Actinfo', params: { id: this.uId }})           
        }           
    },

    async reload(){
      this.type = this.$route.params.type        
      this.uId = this.$route.params.id
      this.check()
      let userid ='null'
      if(this.user!==null){
        userid=this.user.data.user.id
      }
      this.fetch3({id:this.uId,uid:userid});
    },
    
    toNext(){
      router.go(-1)
    },     

  },  
}
</script>
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.sidenav a:hover {
  color: #064579;
}
.applyfooter {
   position: fixed;
   left: 0;
   bottom: 0;
   width: 100%;
   height: 0px;
   background-color: #f0f8f8;
   color: #f0f8f8;
   text-align: center;
   
}
.lineHeader {
   position: fixed;
   left: 0;
   top: 0;
   z-index: 7;
   opacity:1;
   width: 100%;
   height: 3.4rem;
   padding: 0.4em;
   background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
   color: #495057;
   text-align: center;
   box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
   backdrop-filter: blur(10px);
}
.fontstyle{
   font-size:0.8rem;
   color:#faf8f8;
}

.fontstyle-large{
   font-size: 0.9rem;
   color: #495057;
   font-weight: 500;
   padding: 0.8rem 1.3rem;
   min-height: 2.4rem;
   display: flex;
   align-items: center;
   justify-content: center;
   border-radius: 25px;
   background: rgba(52, 58, 64, 0.08);
   backdrop-filter: blur(10px);
   border: 1px solid rgba(52, 58, 64, 0.15);
   transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
   box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
   text-shadow: 0 1px 2px rgba(255, 255, 255, 0.5);
}

.fontstyle-large:hover{
   background: rgba(52, 58, 64, 0.15);
   color: #343a40;
   transform: translateY(-2px);
   box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
   border-color: rgba(52, 58, 64, 0.25);
}

.fontstyle-large:active{
   transform: translateY(0px);
   box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
}

.fontstyle2{
   font-size:0.8rem;
   color:#447dc7;
}

.fontstyle2-large{
   font-size: 0.9rem;
   color: #4f46e5;
   font-weight: 500;
   padding: 0.8rem 1.3rem;
   min-height: 2.4rem;
   display: flex;
   align-items: center;
   justify-content: flex-start;
   border-radius: 20px;
   background: linear-gradient(135deg, #ffffff, #f8fafc);
   border: 2px solid #e0e7ff;
   transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
   box-shadow: 0 4px 15px rgba(79, 70, 229, 0.1);
   text-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.fontstyle2-large:hover{
   background: linear-gradient(135deg, #f0f4ff, #e0e7ff);
   color: #3730a3;
   transform: translateY(-3px);
   box-shadow: 0 8px 25px rgba(79, 70, 229, 0.2);
   border-color: #c7d2fe;
}

.fontstyle2-large:active{
   transform: translateY(-1px);
   box-shadow: 0 4px 15px rgba(79, 70, 229, 0.15);
}


</style>

